import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './actions';
import View from './view';
import * as OrganizationsSelectors from 'shared_redux/selectors/models/organizations';
import * as AccountsSelectors from 'shared_redux/selectors/models/accounts';
import * as OrganizationSwitcherSelectors from 'shared_redux/selectors/view/organization_switcher';

const mapStateToProps = (state) => {
    const organization = OrganizationsSelectors.getOrganization(state);
    const account = AccountsSelectors.getAccount(state);
    const availableOrganizations = OrganizationSwitcherSelectors.getAvailableOrganizations(state);
    const currentOrganization = OrganizationSwitcherSelectors.getCurrentOrganization(state);
    
    return {
        logoURL: "https://assets.reponestrength.com/white_logo.png",
        email: account ? account.email : 'Account',
        availableOrganizations,
        currentOrganization,
        isPersonal: OrganizationSwitcherSelectors.getIsCurrentOrganizationPersonal(state),
        organizationName: currentOrganization ? currentOrganization.organization.name : (organization ? organization.name : 'Organization'),
        organizationLogoURL: currentOrganization?.organization?.logo_url || organization?.logo_url || null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchAccount: Actions.fetchAccount,
        signOut: Actions.signOut,
        fetchAccountOrganizations: Actions.fetchAccountOrganizations,
        switchOrganization: Actions.switchOrganization,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default withRouter(Container);
